const getProviderName = (recordMode: number, provideId: string) => {
  if (recordMode === 2) {
    return "local";
  }

  if (provideId === "1") {
    return "digitro";
  }

  if (provideId === "2") {
    return "mconf";
  }

  return "local";
};

export const isDigitroProvider = (recordMode: number, provideId: string) =>
  getProviderName(recordMode, provideId) === "digitro";

export const isLocalProvider = (recordMode: number, provideId: string) =>
  getProviderName(recordMode, provideId) === "local";

export const isMConfProvider = (recordMode: number, provideId: string) =>
  getProviderName(recordMode, provideId) === "mconf";
